<dcl-script-loader [src]="fontFaceScriptUrl"></dcl-script-loader>
<dcl-css-loader [src]="fontFaceCssUrl"></dcl-css-loader>
